export const Burst = ({ text, subtext, color = "#FFD700", textColor = "#111111", className = "", rotate = "-rotate-6" }) => (
  <div className={`relative inline-flex items-center justify-center ${rotate} ${className}`} data-testid={`burst-${(text || "").toLowerCase().replace(/\s+/g, "-")}`}>
    <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[4px_4px_0_#111111]">
      <path
        d="M100 4 L114 34 L146 18 L150 52 L186 46 L178 80 L212 88 L194 116 L222 136 L196 156 L214 186 L180 186 L186 220 L154 210 L146 244 L120 220 L100 248 L82 220 L54 242 L50 208 L14 214 L24 180 L-8 168 L14 142 L-12 120 L12 100 L-10 76 L22 68 L12 34 L48 44 L54 10 L82 28 Z"
        transform="scale(0.88) translate(13 13)"
        fill={color}
        stroke="#111111"
        strokeWidth="5"
        strokeLinejoin="round"
      />
    </svg>
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center leading-none px-4">
      <span className="font-display font-bold uppercase" style={{ color: textColor, fontSize: "clamp(0.8rem, 1.6vw, 1.15rem)" }}>{text}</span>
      {subtext && <span className="font-body font-extrabold uppercase mt-1" style={{ color: textColor, fontSize: "clamp(0.55rem, 1vw, 0.75rem)" }}>{subtext}</span>}
    </div>
  </div>
);
